module.exports = __webpack_public_path__ + "img/quan.652c86a5.png";